import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { useDictionaries } from 'entities/creditForm';

export const AdditionalPhoneOwner: FC<IFieldFactoryProps> = (props) => {
  const { additionalPhoneOwners } = useDictionaries(['additionalPhoneOwners']);
  const { type, ...other } = props;

  return (
    <ControlledCustomSelect
      {...other}
      name={type}
      options={additionalPhoneOwners}
      withCrossIcon={false}
    />
  );
};
